<template>
  <div>
    <el-table
      class="alttable table-xs"
      style="width: 100%"
      width="100%"
      v-if="data"
      :data="data.Kasa"
      row-key="id"
      show-summary
      :summary-method="TableFooter"
      :height="Height"
      @current-change="KasaSecim"
      default-expand-all>
      <el-table-column
        prop="Adi"
        label="Kasa Adı">
      </el-table-column>
      <el-table-column
        prop="BlokeText"
        label="Bloke"
        align="right"
        width="90">
      </el-table-column>
      <el-table-column
        prop="GelirText"
        label="Gelir"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="GiderText"
        label="Gider"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="BakiyeText"
        label="Bakiye"
        align="right"
        width="100">
      </el-table-column>
    </el-table>

    <KasaDetay :data="KasaDetay" @KasaDetayModal="KasaDetayModal=false" :KasaDetayModal="KasaDetayModal"
               v-if="KasaDetay"></KasaDetay>
  </div>
</template>

<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";
import KasaDetay from "./KasaDetay";

export default {
  components: {KasaDetay, Yukleniyor},
  props: ["data", "Bina_id"],
  data() {
    return {
      lo: true,
      KasaDetayModal: false,
      Kasalar: null,
      Height: (window.innerHeight / 2) - 120,
      Grafik: null,
      SiteKasa: null,
      KasaDetay: null,
    }
  },
  methods: {
    TableFooter() {
      const sums = [];
      sums[1] = this.data.Bakiye.Bloke;
      sums[2] = this.data.Bakiye.Gelir;
      sums[3] = this.data.Bakiye.Gider;
      sums[4] = this.data.Bakiye.Bakiye;
      return sums;
    },
    KasaSecim(val) {
      this.KasaDetayModal = true;
      this.KasaDetay = {
        Kasa_id: val.id,
        Bina_id: this.Bina_id,
        Baslik: val.Adi
      };
    },
  },
  created() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/KasaTable.vue